export const iconFontAwesomeTextformattingRectangleList = (
	<i className="fa-solid fa-rectangle-list"></i>
);
